export async function getList({ /*token,*/ uid }) {
    const url = 'https://reports.imon.gulfnet-cloud.com/v1/summaries';
    const params = { /*token: token,*/ uid: uid };
    const query_params = new URLSearchParams(params);
    const init_params = {
        credentials: "same-origin"
    }
    const res = await fetch(url + '?' + query_params, init_params);
    //return await fetch(url + '?' + query_params);
    //return JSON.parse(res.json());
    return res.json();
}
